module.exports = __webpack_public_path__ + "img/vip-line.4c6d3b54.svg";